// Запуск MSW worker'а.
//
// MSW по умолчанию ВЫКЛЮЧЕН — dev/prod идут в реальный backend (Fastify :3000
// через Vite proxy). Моки включаются ТОЛЬКО при явном `VITE_USE_MOCKS=true`
// (unit/e2e-тесты, демо без backend). MSW-инфраструктура (handlers/browser)
// сохранена для тестов — не удалять.
//
// Двухуровневый guard:
//   1. Build-time: `import.meta.env.DEV` — в prod билде вся ветка превращается
//      в `return;` ↦ Rollup полностью tree-shake'ает динамический import, и
//      browser-*.js + handler-чанки НЕ попадают в dist (zero MSW footprint).
//   2. Runtime: `VITE_USE_MOCKS=true` — в dev оставляем явный opt-in.
//
// Service worker лежит в `public/mockServiceWorker.js` (если нет — `npx msw init public/`).
export async function enableMocking(): Promise<void> {
	if (!import.meta.env.DEV) return;

	const useMocks = import.meta.env.VITE_USE_MOCKS;
	if (useMocks !== "true" && useMocks !== true) return;

	try {
		const { worker } = await import("./browser");
		await worker.start({
			onUnhandledRequest: "bypass",
			serviceWorker: {
				url: "/mockServiceWorker.js",
			},
		});
		// eslint-disable-next-line no-console -- intentional dev banner
		console.info("[MSW] mocks enabled");
	} catch (err) {
		// eslint-disable-next-line no-console -- intentional dev diagnostic
		console.warn("[MSW] failed to start, continuing without mocks", err);
	}
}
